import React from "react";
import { LanderTemplate } from "../commons/constants/Templates";
import SimpleLayout from "./cashparking/SimpleLayout";
import HegLayout from "./parkweb/HegLayout";
import ParkWebLayout from "./parkweb/ParkWebLayout";
import { useLanderConfig } from "../commons/ConfigContext";
import { useRsoc } from "../rsoc/useRsoc";

export default function LanderRouter() {
  const { landerConfig } = useLanderConfig();
  const { rsocRedirectEnabled } = useRsoc();
  if (rsocRedirectEnabled) {
    // don't show lander if we are redirecting to RSoc
    return null;
  }

  switch (landerConfig.lander.template) {
    case LanderTemplate.PARK_WEB:
      return <ParkWebLayout />;
    case LanderTemplate.PARK_WEB_HEG:
      return <HegLayout />;
    default:
      return <SimpleLayout />;
  }
}
